<!----
    Author: hjlee
    Description:
        사용자 프로필 이미지 컨트롤
---->
<template>
  <div class="profile-img-area">
    <centered-image
      v-if="shownImage && innerUser && innerUser.thumb"
      :key="'image-' + innerUser.id + '-' + getImgUrl(innerUser.thumb)"
      :class="{'img-profile': true, 'clickable': showOriginal && innerUser && innerUser.thumb}"
      :src="getImgUrl(innerUser.thumb)"
      :alt="innerUser.nm + '(' + innerUser.userId + ')'"
      :cover="true"
      @click="showImageViewer()"
    />
    <centered-image
      v-else-if="shownImage && innerUser"
      :key="'image-' + innerUser.id + '-/img/gnb/empty_profile.png'"
      class="img-profile"
      src="/img/gnb/empty_profile.png"
      :alt="innerUser.nm + '(' + innerUser.userId + ')'"
      :cover="true"
    />

    <image-viewer v-if="shownImage && innerUser && innerUser.thumb" ref="imageViewerRef" :src="getImgUrl(innerUser.thumb, 1600)" :alt="innerUser.nm + '(' + innerUser.userId + ')'" />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 0
    },
    user: {
      type: Object,
      default: undefined
    },
    showOriginal: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      innerUser: undefined,
      isShowOriginal: false,
      shownImage: false
    }
  },
  watch: {
    isShowOriginal(newVal, oldVal) {
      if (newVal) {
        $(this.$el)
          .find('.original-image-area')
          .fadeIn()
      } else {
        $(this.$el)
          .find('.original-image-area')
          .fadeOut()
      }
    },
    loggedInUser: {
      handler(newVal, oldVal) {
        this.innerUser = newVal
        this.$forceUpdate()
      },
      deep: true,
      immediate: true
    },
    innerUser: {
      handler(newVal, oldVal) {
        this.redrawImage()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if (this.user) {
      this.innerUser = this.user
    } else {
      this.innerUser = this.loggedInUser
    }
    setTimeout(() => {
      if (this.user) {
        this.innerUser = this.user
      } else {
        this.innerUser = this.loggedInUser
      }
    }, 1000)
    if (this.size) {
      $(this.$el).width(this.size)
      $(this.$el).height(this.size)
    } else {
      $(this.$el).css('width', '100%')
      $(this.$el).css('height', '100%')
    }
    this.$eventHub.$on('logged-in-user-changed', this.onLoggedInUserChanged)
  },
  beforeDestroy() {
    this.$eventHub.$off('logged-in-user-changed', this.onLoggedInUserChanged)
  },
  methods: {
    onLoggedInUserChanged(param) {
      this.innerUser = param
      this.$forceUpdate()
    },
    showImageViewer: function() {
      if (this.showOriginal) {
        this.$refs.imageViewerRef.showImageViewer()
      }
    },
    redrawImage() {
      this.shownImage = false
      this.$forceUpdate()
      this.$nextTick(() => {
        this.shownImage = true
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style scoped>
.profile-img-area {
  border: 2px solid #ffffff;
  overflow: hidden;
  margin: auto;
  border-radius: 50%;
  background-image: url('/img/gnb/empty_profile.png');
  background-size: 100%;
}
.original-image-area {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: none;
  z-index: 2000;
}
</style>
